import { Record } from 'immutable';
import { schema } from 'normalizr';

export const SmartlinkModel = new Record({
  id: undefined,
  display_name: '',
  maximum_number_of_relays: undefined,
  relay_count_varies_by_unit: undefined,
  measures_current_in_amps: undefined,
  measures_generated_power: undefined,
  measures_complex_ac_power: undefined,
  supports_triface_motors: undefined,
  input_voltage: undefined,
  hardware_platform: undefined,
  minimum_firmware_version_supported_id: undefined,
  has_dual_ansi_consumption_meters: undefined,
  supports_relay_pairing: undefined,
  is_obsolete: undefined,
  maximum_schedules_per_relay: undefined,
  supports_day_of_week_schedules: undefined,
});

export const smartlinkModelSchema = new schema.Entity('smartlinkModels');
